export type TikTokPixelConfig =
  | { kind: 'id'; pixelId: string }
  | { kind: 'script'; body: string };

const PIXEL_ID_PATTERN = /^[A-Z0-9]{6,40}$/i;
const PIXEL_ID_IN_LOAD = /ttq\.load\(\s*['"]([A-Z0-9]{6,40})['"]/i;

export function resolveTikTokPixel(raw: string | null | undefined): TikTokPixelConfig | null {
  const value = raw?.trim() ?? '';
  if (!value) return null;

  const pixelId = extractPixelId(value);
  if (pixelId) return { kind: 'id', pixelId };

  const body = extractScriptBody(value);
  if (body) return { kind: 'script', body };

  return null;
}

function extractPixelId(value: string): string | null {
  if (PIXEL_ID_PATTERN.test(value)) return value;
  return value.match(PIXEL_ID_IN_LOAD)?.[1] ?? null;
}

function extractScriptBody(value: string): string | null {
  const withoutComments = value.replace(/<!--[\s\S]*?-->/g, '').trim();
  const fromTags = [...withoutComments.matchAll(/<script\b[^>]*>([\s\S]*?)<\/script>/gi)]
    .map((match) => match[1].trim())
    .filter(Boolean)
    .join('\n');
  if (fromTags) return fromTags;
  if (/\bttq\b/.test(withoutComments) || /TiktokAnalyticsObject/.test(withoutComments)) {
    return withoutComments;
  }
  return null;
}

export function buildTikTokPixelScript(pixelId: string): string {
  return `!function(w,d,t){w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e};ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var s=d.createElement("script");s.type="text/javascript",s.async=!0,s.src=r+"?sdkid="+e+"&lib="+t;e=d.getElementsByTagName("script")[0];e.parentNode.insertBefore(s,e)};ttq.load('${pixelId}');ttq.page()}(window,document,'ttq');`;
}
